<template>
  <VModal :disable-backdrop-click="false" @close="onClose">
    <template #default>
      <div class="mx-auto my-auto bg-white rounded p-2">
        <Loader />
      </div>
    </template>
  </VModal>
</template>

<script>
import { duplicatedEmailTemplatesClient } from '@/api/clients';

export default {
  props: {
    emailTemplateId: {
      type: String,
      required: true,
    },
  },
  created() {
    this.handleDuplicate();
  },
  methods: {
    async handleDuplicate() {
      try {
        await duplicatedEmailTemplatesClient.store({ email_template_id: this.emailTemplateId });

        this.$emit('duplicated');

        this.onClose();
      } catch (error) {
        this.onClose();
      }
    },
    onClose() {
      this.$emit('close');
    },
  },
};
</script>
